import { render, staticRenderFns } from "./Retrieve.vue?vue&type=template&id=fddb2db4&scoped=true"
import script from "./Retrieve.vue?vue&type=script&lang=js"
export * from "./Retrieve.vue?vue&type=script&lang=js"
import style0 from "./Retrieve.vue?vue&type=style&index=0&id=fddb2db4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fddb2db4",
  null
  
)

export default component.exports